import { Vue, Component } from 'vue-property-decorator';
import { toI18n } from '@/utils/commonUtils';

@Component
export default class PageSizeData extends Vue {
  private title: string = this.toI18n('BOARD_MIXINS_VIEWS');
  public pageSizeData: { value: string; label: string }[] = [
    { value: '15', label: '15' + this.title },// 15개 보기
    { value: '30', label: '30' + this.title },// 30개 보기
    { value: '50', label: '50' + this.title },// 50개 보기
  ];

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }
}